import { useParams } from 'react-router-dom';
import Footer from '../components/Footer.jsx';
import NotFoundPage from './NotFoundPage.jsx';
import { getPostBySlug } from '../lib/content.js';

const DEFAULT_HEADER = '/images/default_trail_header-heading.jpg';

/** Single blog post (single.php). */
export default function BlogPostPage() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) return <NotFoundPage />;

  const header = post.headerImage || post.thumbnail || DEFAULT_HEADER;

  return (
    <>
      <div
        className="page-banner"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${header})`,
        }}
      >
        <div className="row" style={{ height: '100%' }}>
          <div className="col-2"></div>
          <div className="col-8 page-banner-textarea">
            <div className="row page-banner-heading-text">{post.title}</div>
            <div className="row page-banner-tagline-text">{post.tagline}</div>
          </div>
          <div className="col-2"></div>
        </div>
      </div>

      <div className="container-fluid page-textarea">
        <div className="row">
          <div className="col-2"></div>
          <div
            className="col-8 page-text"
            dangerouslySetInnerHTML={{ __html: post.content }}
          ></div>
          <div className="col-2"></div>
        </div>
      </div>

      <Footer />
    </>
  );
}
